import { ProductVariantColor_ } from 'src/api/db/apiProductVariantColor'
import { Column, Row } from 'src/shared/components/Semantic/all'
import { Image, ScrollArea } from 'src/shared/components/ui'
import { cn } from 'src/shared/components/ui/utils'

export const PickColor = ({
  chosen_product_variant_color_,
  product_variant_colors,
  setProduct_variant_color,
}: {
  chosen_product_variant_color_: ProductVariantColor_
  product_variant_colors: ProductVariantColor_[]
  setProduct_variant_color: (color_id: number) => void
}) => {
  return (
    <>
      <ScrollArea className="h-[200px] mt-2">
        <div className="grid grid-cols-3 gap-2">
          {product_variant_colors?.map((colorVariant) => {
            const { id } = colorVariant
            let illustrations = colorVariant.product_image ?? []
            illustrations = illustrations.sort(
              (a, b) => (a?.order ?? 0) - (b?.order ?? 0)
            )
            const image_url = illustrations?.[0]?.image_url
            const isSelected = chosen_product_variant_color_?.id === id

            console.log('colorVariant', colorVariant)

            return (
              <Column
                key={id}
                className={cn(
                  'rounded-sm flex items-center justify-center relative gap-1 p-1'
                )}
              >
                <Image
                  src={image_url || ''}
                  className="object-contain cursor-pointer rounded-md"
                  onClick={() => {
                    setProduct_variant_color(id)
                  }}
                />

                <Row className="items-center gap-1">
                  <p
                    className={cn(
                      'text-xs',
                      isSelected ? 'font-medium' : 'font-normal'
                    )}
                  >
                    {colorVariant.color}
                  </p>

                  {isSelected && (
                    <div className="w-2 h-2 rounded-full bg-black" />
                  )}
                </Row>
              </Column>
            )
          })}
        </div>
      </ScrollArea>
    </>
  )
}
